import React, { useState } from 'react';
import Button from 'ui/Button';
import Spinner from '../../../ecoui/UISpinner';
import { formatDenmarkCurrency } from 'utils/UiHelper';
import PaymentConfirm from 'features/SpilKlub/components/PaymentConfirm';
import PoolInfoBlocks from './PoolInfoBlocks';
import BuyShares from './BuyShares';
import Coupons from './Coupons';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as UiActions from 'actions/UiActions';
import * as AuthActions from 'actions/AuthActions';

const DeferredValue = ({ value }) =>
    value ? (
        `${value} kr.`
    ) : (
        <Spinner plain size="fa-05x" className="no-padding" />
    );

const SharePrice = ({ sharePrice }) => (
    <div className="flex flex-columns">
        <span className="pool-details-share-price-label">Andelspris</span>
        <span className="pool-details-share-price">
            <DeferredValue value={sharePrice} />
        </span>
    </div>
);

const PoolSummary = ({
    auth,
    pool,
    status,
    authActions,
    isPoolOwner,
    refetchPoolDetails,
    uiActions,
}) => {
    const [selectShares, setSelectShares] = useState(0);
    const [showPaymentConfirm, setShowPaymentConfirm] = useState(false);
    const balance = auth?.user?.balance;

    const sharePrice = pool?.poolSettings?.sharePrice;

    return (
        <div className="pool-details-summary-container">
            <div className="flex space-between">
                <SharePrice sharePrice={sharePrice} />
                <BuyShares
                    pool={pool}
                    status={status}
                    selectShares={selectShares}
                    setSelectShares={setSelectShares}
                    onClick={() => setShowPaymentConfirm(true)}
                />
            </div>

            <div className="fs-14 lh-20 font-thick top-indent-md bottom-indent-md">
                Køber du én eller flere andele, vil du være med i den eller de
                kuponer, som kaptajnen placerer. Når kaptajnen har lavet den
                endelige kupon(er), finder du den under "Mine spil".
            </div>

            <PoolInfoBlocks pool={pool} status={status} />

            {pool?.poolHash && (
                <Coupons
                    coupons={pool?.coupons}
                    poolHash={pool?.poolHash}
                    pool={pool}
                    isPoolOwner={isPoolOwner}
                    refetchPoolDetails={refetchPoolDetails}
                />
            )}

            {/*{sharePrice &&*/}
            {/*    selectShares > 0 && (*/}
            {/*        <div className={'sk-pools-submit-wrapper'}>*/}
            {/*            <Button*/}
            {/*                width={'300px'}*/}
            {/*                className={'sk-pools-submit-button'}*/}
            {/*                active*/}
            {/*                justify={'space-between'}*/}
            {/*                onClick={() => setShowPaymentConfirm(true)}*/}
            {/*            >*/}
            {/*                <span>{selectShares} andel</span>*/}
            {/*                <span>*/}
            {/*                    {formatDenmarkCurrency(*/}
            {/*                        selectShares * sharePrice*/}
            {/*                    )}{' '}*/}
            {/*                    kr.*/}
            {/*                </span>*/}
            {/*            </Button>*/}
            {/*        </div>*/}
            {/*    )}*/}

            <PaymentConfirm
                balance={balance}
                title={'Bekræft køb'}
                isOpen={showPaymentConfirm}
                onClose={() => setShowPaymentConfirm(false)}
                onSuccess={() => {
                    setShowPaymentConfirm(false);
                    authActions.updateBalance();
                    setSelectShares(0);
                    refetchPoolDetails();
                }}
                uiActions={uiActions}
                groupName={pool?.poolTemplate?.name}
                numberOfShares={selectShares}
                totalPrice={selectShares * sharePrice}
                pool={pool}
                selectShares={selectShares}
                setSelectShares={setSelectShares}
            />
        </div>
    );
};

function mapStateToProps(state) {
    return {
        auth: state.auth,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        uiActions: bindActionCreators(UiActions, dispatch),
        authActions: bindActionCreators(AuthActions, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PoolSummary);
